module.exports = __webpack_public_path__ + "static/img/acq-form-2.6b499c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/acq-form-2.png
// module id = 1b8P
// module chunks = 1